import { Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useDocumentsDataTable } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

type DocumentsDataTableProjection = Parameters<typeof useDocumentsDataTable>[0][number]

const filenameProjection: () => DocumentsDataTableProjection = () => ({
  identifier: 'filename',
  title: i18n.t('documents.employee.list.filename'),
  kind: ProjectionKind.Custom,
  template: '',
  render: ({ filename }) => (
    <Text size="200" weight="semibold" overflowWrap>
      {filename}
    </Text>
  ),
  sortBy: 'filename',
  colSpan: 2,
})

export default filenameProjection
